// extracted by mini-css-extract-plugin
export default {"Container":"RlEsTjgBsVIqKuzXo9kW","Text":"Y7AfNrFGQCKQzotlPE4w"};